export default __webpack_public_path__ + "static/media/logo-syndic-one-full.2036dae3.svg";